// extracted by mini-css-extract-plugin
export var searchHeader = "_73-0";
export var searchHeaderDark = "_73-1";